module.exports = __webpack_public_path__ + "img/ZUMA.e62590ad.png";